"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveSavedIdModal_1 = require("./RemoveSavedIdModal");
exports.default = RemoveSavedIdModal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/RemoveSavedIDModal/index.js
// module id = 588
// module chunks = 8